const fn = {
  init: () => {
    fn.setupForm()
  },

  isEmail: (email) => {
    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/

    return regex.test(email)
  },

  setupForm: () => {
    $('.news-subscribe-form').on('submit', function (e) {
      e.preventDefault()

      const $form = $(this)
      const $email = $form.find('[name=Email]')
      const $message = $form.find('.message')
      const $submitButton = $form.find('[type=submit]')

      $message.hide()

      if ($email.val() === '' || !fn.isEmail($email.val())) {
        $message.filter('.empty').show()
        $email.focus()

        return false
      }

      $submitButton.prop('disabled', true)

      $.ajax({
        type: 'post',
        url: $form.prop('action'),
        data: $form.serialize(),
        dataType: 'json',
        success: resp => {
          if (resp.success) {
            $email.val(null)
            $message.filter('.success').show()
          } else {
            $message.filter('.duplicate').show()
          }
        },
        complete: () => {
          $submitButton.prop('disabled', false)
        }
      })
    })
  }
}

export default {
  can: () => true,
  run: fn.init
}
